import { HTTPError } from "ky";

export class WidgetApiError extends Error {
  code: string;
  status: number;

  constructor(message: string, status: number, code = "api_error") {
    super(message);
    this.name = "WidgetApiError";
    this.status = status;
    this.code = code;
  }
}

export async function toWidgetApiError(
  error: unknown,
  fallbackMessage: string,
): Promise<WidgetApiError> {
  if (error instanceof WidgetApiError) {
    return error;
  }

  if (error instanceof HTTPError) {
    let errorMessage = fallbackMessage;
    let errorCode = "api_error";

    try {
      const body = (await error.response.json()) as {
        error?: string;
        code?: string;
      };
      errorMessage = body.error || fallbackMessage;
      errorCode = body.code || errorCode;
    } catch {
      errorMessage = fallbackMessage;
    }

    return new WidgetApiError(errorMessage, error.response.status, errorCode);
  }

  return new WidgetApiError(
    error instanceof Error ? error.message : fallbackMessage,
    500,
    "unknown_error",
  );
}

export function widgetConfigQueryShouldRetry(failureCount: number, error: unknown): boolean {
  if (error instanceof WidgetApiError && [401, 403].includes(error.status)) {
    return false;
  }
  return failureCount < 3;
}

export function widgetConfigQueryRetryDelay(attemptIndex: number): number {
  return Math.min(1000 * 2 ** attemptIndex, 5000);
}
